// Youssef Selkani
// 2019

import React, { Component, createRef } from 'react'
import '../App.css'
import {
  Table,
  Segment,
  Image,
  Loader,
  Icon,
  Header,
  Transition,
  Grid,
  Label,
  Placeholder,
  Divider,
  Message
} from 'semantic-ui-react'
import AdSense from 'react-adsense'
import ScrollArea from '@xico2k/react-scroll-area'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import Search from 'react-search'
import Mailto from 'react-protected-mailto'
import AdBlockDetect from 'react-ad-block-detect'
import DetectAdBlock from '../components/DetectAdBlock'
import Img from 'react-image'
import ReactPlayer from 'react-player'
import GoogleMapReact from 'google-map-react'
// import { Parallax, ParallaxBanner } from 'react-scroll-parallax'

const ImgLoader = (
  <Placeholder fluid style={{ height: 200, width: 400 }}>
    <Placeholder.Image />
  </Placeholder>
)
export default class PublicSheet extends Component {
  constructor (props) {
    super(props)
    this.state = {
      done: false,
      error: null,
      result: [],
      components: [],
      columns: [],
      rows: [],
      sheetID: null,
      columnsLength: null,
      singleRow: false,
      newCompLabel: '',
      theme: 'wrap',
      selectComp: false,
      selectSource: false,
      selectLabel: false,
      copied: false,
      blurOn: false,
      calculations: {
        pixelsPassed: 0
      }
    }
  }
  componentDidMount = () => {
    this.setState({ loading: true })
    const {
      match: { params }
    } = this.props
    this.setState(
      {
        sheetID: params.sheetid
      },
      () => {
        this.pullOwner()
      }
    )
  }

  pullOwner = (e) => {
    this.setState({ loading: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/sheet/info', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sheetID: this.state.sheetID
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if ((json.code = 200)) {
          this.setState(
            {
              owner: json.owner,
              title: json.title
            },
            () => {
              this.sheetData()
            }
          )
        } else {
          this.setState({
            loading: false,
            error: json.code
          })
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.setState({ error: error.message, loading: false })
      })
  }

  sheetData = (e) => {
    window.scrollTo(0, 0)
    this.setState({ loading: true })
    let owner = this.state.owner
    let userUnderscore = owner.replace(/\./g, '_')

    fetch('https://murkstomstag.herokuapp.com/api/v1/sheet/data', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sheetID: this.state.sheetID,
        userUnderscore: userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if ((json.code = 200)) {
          this.setState(
            {
              selectedValue1: json.selectedValue1,
              selectedValue2: json.selectedValue2,
              selectedValue3: json.selectedValue3,
              selectedImage: json.selectedImage
            },
            () => {
              this.sheet()
            }
          )
        } else {
          this.setState({
            loading: false,
            error: json.code
          })
        }
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false })
      })
  }

  sheet = () => {
    var self = this
    var request = new Request('https://sheetjson.herokuapp.com/api?id=' + self.state.sheetID)
    fetch(request)
      .then(function (result) {
        return result.json()
      })
      .then(function (result) {
        var rows = []
        var columns = []
        for (let column in result.columns) {
          columns.push({
            value: column,
            text: column,
            key: column
          })
        }
        var dataR = result.rows
        for (let row in dataR) {
          var value = dataR[row]
          rows.push({ value })
        }
        let reverseRow = rows.reverse()
        let items = reverseRow.map((res, i) => {
          return {
            id: i,
            value:
              res.value[self.state.selectedValue1] +
              ' ' +
              res.value[self.state.selectedValue2] +
              ' ' +
              res.value[self.state.selectedValue3]
          }
        })
        self.setState({
          columnsLength: Object.keys(result.columns).length,
          rowsLength: Object.keys(result.rows).length,
          columns: columns,
          rows: rows,
          done: true,
          singleRow: false,
          data: items
        })
        self.sheetComponents()
      })
      .catch(function (err) {
        console.log(err)
      })
  }

  sheetComponents = (e) => {
    window.scrollTo(0, 0)
    this.setState({ loading: true })
    let owner = this.state.owner
    let userUnderscore = owner.replace(/\./g, '_')
    fetch('https://murkstomstag.herokuapp.com/api/v1/sheet/components', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sheetID: this.state.sheetID,
        userUnderscore: userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if ((json.code = 200)) {
          this.setState({
            components: json.components,
            componentsIndex: json.componentsIndex,
            loading: false
          })
        } else {
          this.setState({
            loading: false,
            error: json.code
          })
        }
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false })
      })
  }

  singleRow = (index, item, e) => {
    window.scrollTo(0, 0)
    this.setState({
      singleRow: true,
      done: false,
      index: item.value
    })
  }

  goBack = (e) => {
    this.setState({
      done: true,
      singleRow: false,
      selectedIndex: null
    })
  }

  handleItemsChange (items) {
    var self = this
    if (items[0] !== undefined) {
      window.scrollTo(0, 0)
      self.setState({
        index: self.state.rows[items.reverse()[0].id].value,
        singleRow: true,
        done: false
      })
    }
  }

  render () {
    let { done, loading, selectedImage, error, index, singleRow, title, selectedIndex } = this.state

    const rows = this.state.rows.map((item, index) => (
      <div className='cursor' key={index}>
        <Table.Row inverted onClick={() => this.singleRow(index, item)} verticalAlign='middle'>
          <Table.Cell singleLine collapsing>
            {selectedImage && (
              <Image
                size='mini'
                centered
                rounded
                spaced
                src={item.value[this.state.selectedImage]}
              />
            )}
          </Table.Cell>
          <Table.Cell>
            <h3>{item.value[this.state.selectedValue1]}</h3>
          </Table.Cell>
          <Table.Cell>{item.value[this.state.selectedValue2]}</Table.Cell>
          <Table.Cell>{item.value[this.state.selectedValue3]}</Table.Cell>
        </Table.Row>
        <Divider />
      </div>
    ))

    var _this = this
    const componentsMobile = this.state.components.map((item, index) => (
      <CopyToClipboard
        text={_this.state && _this.state.index && _this.state.index[item.value.source]}
        onCopy={() => {
          this.setState({
            selectedIndex: index
          })
        }}>
        <div className='cursor public-card lightshadow' style={{ color: '#000' }} key={index}>
          {item.value.type === 'text' && (
            <div style={{ color: '#000' }}>
              <h4>
                <b>{item.value.label}</b>
              </h4>
              <p>{_this.state && _this.state.index && _this.state.index[item.value.source]}</p>
            </div>
          )}

          {item.value.type === 'url' && (
            <div className='wraptext'>
              <h4>
                <b>{item.value.label}</b>
              </h4>
              <a
                href={_this.state && _this.state.index && _this.state.index[item.value.source]}
                rel='noopener noreferrer'
                target='_blank'>
                {_this.state && _this.state.index && _this.state.index[item.value.source]}
              </a>
            </div>
          )}

          {item.value.type === 'email' && (
            <div>
              <h4>
                <b>{item.value.label}</b>
              </h4>
              <Mailto
                email={_this.state && _this.state.index && _this.state.index[item.value.source]}
              />
            </div>
          )}
          {item.value.type === 'phone' && (
            <div>
              <h4>
                <b>{item.value.label}</b>
              </h4>
              <Mailto
                tel={_this.state && _this.state.index && _this.state.index[item.value.source]}
              />
            </div>
          )}

          {item.value.type === 'address' && (
            <div style={{ height: '300px', width: '100%' }}>
              <GoogleMapReact
                defaultCenter={{ lat: 59.95, lng: 30.33 }}
                defaultZoom={10}
                bootstrapURLKeys={{ key: 'AIzaSyBYCM8OCMwFVPhexSvnmV8BlCRdJkZde_Y' }}
              />
            </div>
          )}

          {item.value.type === 'image' && (
            <Image
              src={_this.state && _this.state.index && _this.state.index[item.value.source]}
              fluid
            />
          )}
          {item.value.type === 'video' && (
            <ReactPlayer
              url={_this.state && _this.state.index && _this.state.index[item.value.source]}
              width='100%'
              height='40vh'
            />
          )}
          {item.value.type === 'audio' && (
            <ReactPlayer
              url={_this.state && _this.state.index && _this.state.index[item.value.source]}
              controls
              width='100%'
              height='50px'
            />
          )}
          {selectedIndex === index ? (
            <Message compact>
              <Icon name='check' style={{ color: 'green' }} />
              <span>Copied to clipboard</span>
            </Message>
          ) : null}
        </div>
      </CopyToClipboard>
    ))

    return (
      <div
        style={{
          minHeight: '100vh'
        }}>
        {error && <h3>{error}</h3>}
        {singleRow && !loading && selectedImage && (
          <div
            style={{
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'repeat',
              backgroundImage: 'url(' + index[selectedImage] + ')',
              height: '60vh'
            }}>
            <div
              style={{
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.65)'
              }}
            />
          </div>
        )}

        <Grid stackable style={{ backgroundColor: '#fff' }}>
          <Grid.Column width='4' />
          <Grid.Column width='8' style={{ minHeight: '60vh' }}>
            {loading && (
              <div className='mt'>
                <Placeholder fluid height='60vh'>
                  <Placeholder.Header image>
                    <Placeholder.Line length='medium' />
                    <Placeholder.Line length='short' />
                  </Placeholder.Header>
                  <Placeholder.Paragraph>
                    <Placeholder.Line length='long' />
                    <Placeholder.Line />
                    <Placeholder.Line />
                    <Placeholder.Line />
                    <Placeholder.Line />
                  </Placeholder.Paragraph>
                  <Placeholder.Paragraph>
                    <Placeholder.Line length='long' />
                    <Placeholder.Line />
                    <Placeholder.Line />
                    <Placeholder.Line />
                    <Placeholder.Line />
                  </Placeholder.Paragraph>
                </Placeholder>
              </div>
            )}

            {error && !loading && (
              <div className='mt'>
                <Segment placeholder>
                  <Header icon>
                    <Icon name='file text outline' />
                    {error && <h4>Error {error}</h4>}
                  </Header>
                </Segment>
              </div>
            )}

            <Transition visible={done} animation='fade' duration={250}>
              <div style={{ marginTop: '2vh', borderRadius: 7 }} context={this.contextRef}>
                {done && !loading && !singleRow && (
                  <div>
                    <div className='lightshadow mb' style={{ borderRadius: 99999, padding: '2vh' }}>
                      <Search
                        items={this.state.data}
                        placeholder='Search'
                        NotFoundPlaceholder='Not found.'
                        onItemsChanged={this.handleItemsChange.bind(this)}
                      />
                    </div>
                    <Table
                      stackable
                      fluid
                      padded='very'
                      style={{ margin: 0, borderRadius: 7, borderColor: '#fff' }}
                      verticalAlign='middle'>
                      <div style={{ height: '65vh' }}>
                        <ScrollArea>
                          <div className='center mb'>
                            <h1>{title}</h1>
                          </div>
                          <Table.Body>{rows}</Table.Body>
                        </ScrollArea>
                      </div>
                    </Table>
                  </div>
                )}
              </div>
            </Transition>

            <Transition visible={singleRow} animation='fade up' duration={300}>
              <div style={{ marginTop: selectedImage ? '-40vh' : 0 }}>
                <Grid reversed='mobile' stackable verticalAlign='middle'>
                  <Grid.Column width='10'>
                    {singleRow && selectedImage && (
                      <Img
                        className='dropshadow'
                        src={index[selectedImage]}
                        style={{ width: '100%', resizeMode: 'cover', borderRadius: 7 }}
                        loader={ImgLoader}
                      />
                    )}
                  </Grid.Column>
                  <Grid.Column width='6' textAlign='right'>
                    <div className='cursor mt'>
                      <Icon
                        className='dropshadow'
                        name='close'
                        size='large'
                        circular
                        style={{ color: '#000', backgroundColor: ' #fff' }}
                        onClick={this.goBack}
                      />
                    </div>
                  </Grid.Column>
                </Grid>
                {singleRow && !loading && (
                  <div className='mt'>
                    {/* {selectedImage && <Image fluid src={index[selectedImage]} />} */}
                    {componentsMobile}
                  </div>
                )}
              </div>
            </Transition>

            <div className='mt' style={{ height: '20vh', width: '100%' }}>
              <AdSense.Google
                client='ca-pub-8573101599140905'
                slot='2309113111'
                style={{ display: 'block' }}
                format='fluid'
                layoutKey='-fb+5w+4e-db+86'
              />
              {!loading && (
                <AdBlockDetect>
                  <div className='centerX mt center'>
                    <div>
                      <h4>AdBlock detected!</h4>
                      <p>
                        Nobody likes ads but they are the necessary evil of almost every free
                        service. Do you want to support the people behind this website and help them
                        to operate and evolve it?
                      </p>
                    </div>
                  </div>
                </AdBlockDetect>
              )}
              <DetectAdBlock />
            </div>
          </Grid.Column>
          <Grid.Column width='4' />
        </Grid>
      </div>
    )
  }
}
